const isDocument = (value) =>
  value &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  ('documentId' in value || ('id' in value && 'url' in value));

// A document is normalized through its attributes and an attribute through the
// documents it holds, so the two below refer to each other and one of them has
// to come first.
/* eslint-disable no-use-before-define */
const normalizeValue = (value) => {
  if (Array.isArray(value)) {
    return value.length && value.every(isDocument)
      ? { data: value.map(normalizeDocument) }
      : value.map(normalizeValue);
  }
  if (isDocument(value)) {
    return { data: normalizeDocument(value) };
  }
  return value;
};
/* eslint-enable no-use-before-define */

export const normalizeDocument = (document) => {
  if (!document) {
    return document;
  }
  const { id, documentId, ...attributes } = document;
  return {
    id: documentId || id,
    attributes: Object.fromEntries(
      Object.entries(attributes).map(([key, value]) => [
        key,
        normalizeValue(value),
      ])
    ),
  };
};

export const normalizeStrapiResponse = (response) => ({
  ...response,
  data: Array.isArray(response.data)
    ? response.data.map(normalizeDocument)
    : normalizeDocument(response.data),
});
